import React from 'react';
import { Gift, BookOpen, MessageCircle, Shield } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    icon: BookOpen,
    title: 'BONO #1 – Guía Profesional de Toma de Decisiones Clínicas en Dislexia',
    description: 'Un documento claro y práctico para saber qué trabajar, cuándo avanzar y cuándo reforzar, sin dudar en sesión.',
    image: 'https://cdn.magicpatterns.com/uploads/4WwZdWc8LBo3JZAuFF6ZMo/mock_up_1.jpg',
    color: 'bg-blue-50 text-blue-600'
  }, {
    icon: MessageCircle,
    title: 'BONO #2 – Kit de Comunicación Profesional con Familias',
    description: 'Plantillas listas para informar avances, explicar procesos y alinear expectativas sin desgaste emocional.',
    image: 'https://cdn.magicpatterns.com/uploads/j2GU5cSE6bE69gzhYEg6qj/mockup2.jpg',
    color: 'bg-purple-50 text-purple-600'
  }, {
    icon: Shield,
    title: 'BONO #3 – Plan de Mantenimiento Post-Intervención',
    description: 'Estrategias claras para sostener avances, evitar retrocesos y acompañar a la familia después del proceso terapéutico.',
    image: 'https://cdn.magicpatterns.com/uploads/goZ8xF2vRd3chWzvd1P2i8/mock_up_3.jpg',
    color: 'bg-emerald-50 text-emerald-600'
  }];
  return <section className="py-20 bg-white" data-id="element-2">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3">
        <div className="max-w-6xl mx-auto" data-id="element-4">
          <div className="text-center mb-12" data-id="element-5">
            <span className="inline-block px-4 py-1 rounded-full bg-red-100 text-red-700 font-bold text-sm mb-4 animate-pulse" data-id="element-6">
              BONOS EXCLUSIVOS – SOLO HOY
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-7">
              Al acceder ahora, te llevás estos regalos profesionales
            </h2>
            <p className="text-lg text-slate-600" data-id="element-8">
              Sin costo adicional, pensados para resolver dolores reales del
              consultorio
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-9">
            {bonuses.map((bonus, idx) => <div key={idx} className="bg-white rounded-xl border border-slate-200 shadow-lg hover:shadow-xl transition-shadow overflow-hidden flex flex-col h-full" data-id="element-10">
                {/* Bonus Image */}
                <a href="https://checkout.ebookditales.com/cart/42846653874239:1" className="w-full cursor-pointer focus:outline-none focus:ring-4 focus:ring-teal-500/50 transition-transform hover:scale-[1.02]" aria-label={`Ver detalles de ${bonus.title}`} data-id="element-11">
                  <div className="w-full h-96 bg-gradient-to-br from-slate-50 to-slate-100 overflow-hidden flex items-center justify-center p-4" data-id="element-12">
                    <img src={bonus.image} alt={bonus.title} className="w-full h-full object-contain" data-id="element-13" />
                  </div>
                </a>

                {/* Bonus Content */}
                <div className="p-6 flex flex-col flex-grow" data-id="element-14">
                  <h3 className="font-bold text-slate-900 mb-3 text-lg leading-tight" data-id="element-15">
                    {bonus.title}
                  </h3>
                  <p className="text-slate-600 text-sm leading-relaxed flex-grow" data-id="element-16">
                    {bonus.description}
                  </p>
                  <div className="mt-6 pt-4 border-t border-slate-100" data-id="element-17">
                    <span className="text-xs font-bold text-teal-600 uppercase tracking-wider" data-id="element-18">
                      ✓ Incluido Gratis Hoy
                    </span>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="mt-12 text-center" data-id="element-19">
            <p className="text-xl font-medium text-slate-800" data-id="element-20">
              👉 Accedé ahora y llevate todo el sistema + los bonos
            </p>
          </div>
        </div>
      </div>
    </section>;
}